export const DEFAULT_MESSAGES = {
  thankyou_screen_default_error_message:
    "Apologize, the feedback is not submitted due to some technical issue. Please try again after some time and please make sure you have a stable internet connection.",
  no_internet_connection:
    "No internet connection\nPlease connect to the internet to continue feedback submission",
  try_again:
    "Error submitting your feedback.\nYour feedback matters. Please try again.",
  submitting_feedback: "Submitting feedback",
  dont_close_tab: ", please don't close the tab.",
  already_submitted: "YOU HAVE ALREADY SUBMITTED YOUR FEEDBACK.",
  survey_link_expired: "Sorry! The link has expired.",
};

export const LANGUAGE_CONFIGURATION_KEYS = {
  thankyou_screen_default_error_message:
    "thankyou_screen_default_error_message",
  no_internet_connection: "no_internet_connection",
  try_again: "try_again",
  submitting_feedback: "submitting_feedback",
  dont_close_tab: "dont_close_tab",
  already_submitted: "already_submitted",
  survey_link_expired: "survey_link_expired",
};
